module.exports = __webpack_public_path__ + "img/creamy-mushroom-chicken.a3096429.jpg";